import { Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetBalanceFieldSet, WorksheetGridFieldSection, WorksheetRecordGrid } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';
import { useSelector } from 'react-redux';

let WholePortionAnnexBPreparationMultiTraySection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const lightweightAggregate: boolean = useSelector(
    createWorksheetSelector!('data.Preparation.LightweightAggregate', false)
  );

  return (
    <>
      <NamePrefixModifier appendNamePrefix="Masses.MassMeasurement">
        <ListFieldSection>
          <WorksheetBalanceFieldSet name="Equipment.Balance" />
          <Field input={<NumericInput />} name="BulkDensity" visible={lightweightAggregate} />
        </ListFieldSection>
        <WorksheetGridFieldSection name="WetMassMeasurements">
          <WorksheetRecordGrid
            name="WetMassMeasurements"
            orientation="horizontal"
            rowHeaderWidth={200}
            recordProps={{
              preventRemove: (i) => i === 0,
              width: 130,
              enforceAtLeastOneRecord: true,
              removeConfirm: {
                confirm: true,
                confirmTitle: 'Delete drying tray',
                confirmText: 'Are you sure you want to delete the drying tray? Data cannot be recovered.',
                confirmButtonText: 'Delete',
              },
            }}
            fieldSet={[
              { name: 'TareMass', component: <Field input={<NumericInput />} /> },
              {
                name: 'TareAndWetMass',
                component: <Field input={<NumericInput />} />,
              },
              {
                name: 'WetMass',
                component: <Field input={<TextOutput />} />,
              },
            ]}
          />
        </WorksheetGridFieldSection>
        <ListFieldSection>
          <Field input={<TextOutput />} name="WetMass" />
          <Field input={<TextOutput />} name="Volume" visible={lightweightAggregate} />
        </ListFieldSection>
      </NamePrefixModifier>
    </>
  );
};

WholePortionAnnexBPreparationMultiTraySection = withInjectedProps(WholePortionAnnexBPreparationMultiTraySection);

export { WholePortionAnnexBPreparationMultiTraySection };
export default WholePortionAnnexBPreparationMultiTraySection;
